import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(private httpClient: HttpClient) {}

  get<T>(url: string, header: any) {
      return this.httpClient.get<T>(url, header);
  }
  delete<T>(url: string, header: any) {
      return this.httpClient.delete(url, header);
  }
  post<T>(url: string, data: any, header: any) {
      return this.httpClient.post(url, data, header);
  }
}
